import { API_ENDPOINTS } from './api-config';

export interface OutputSchema {
  type: string;
  properties: Record<string, {
    type: string;
    description?: string;
  }>;
}

export interface ExaTaskRequest {
  instructions: string;
  outputSchema: OutputSchema;
  model?: "exa-research-fast" | "exa-research" | "exa-research-pro";
}

export interface ExaTaskResponse {
  researchId: string;
}

export interface ExaTaskStatusResponse {
  researchId: string;
  status: "pending" | "running" | "processing" | "completed" | "failed";
  output?: {
    content: string;
    parsed: Record<string, any>;
  };
  sources?: Array<{
    title?: string;
    url?: string;
    text?: string;
  }>;
}

export async function generateOutputSchema(
  prompt: string
): Promise<OutputSchema> {
  const response = await fetch(API_ENDPOINTS.generateSchema, {
    headers: {
      "Content-Type": "application/json",
    },
    method: "POST",
    body: JSON.stringify({ prompt }),
  });

  if (!response.ok) {
    throw new Error(`Failed to generate schema: ${response.statusText}`);
  }

  return await response.json();
}

export async function createExaResearchTask(
  instructions: string,
  outputSchema: OutputSchema
): Promise<ExaTaskResponse> {
  const response = await fetch(API_ENDPOINTS.exaResearchTasks, {
    headers: {
      "Content-Type": "application/json",
    },
    method: "POST",
    body: JSON.stringify({
      instructions,
      outputSchema,
      model: "exa-research-fast",
    }),
  });

  if (!response.ok) {
    throw new Error(`Failed to create Exa research task: ${response.statusText}`);
  }

  return await response.json();
}

export async function getExaTaskStatus(
  researchId: string
): Promise<ExaTaskStatusResponse> {
  const response = await fetch(API_ENDPOINTS.exaResearchTaskById(researchId), {
    headers: {
      "Content-Type": "application/json",
    },
    method: "GET",
  });

  if (!response.ok) {
    throw new Error(`Failed to get Exa task status: ${response.statusText}`);
  }

  return await response.json();
}
